module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -8.7fc8f63d.png";